import React from "react";
import {
  Image,
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import { AppImages } from "../../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";

const InefficientBeltsPopup = ({ showPopup, closePopup }) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();

  return (
    <Modal
      transparent={true}
      visible={showPopup}
      onRequestClose={closePopup}
      animationType="fade"
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.76)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            backgroundColor: AppColors.black_121212,
            padding:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 10
                : 20,
            marginVertical: 20,
            borderRadius: 10,
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "95%"
                : 347,
            alignItems: "center",
            borderWidth: 1,
            borderColor: AppColors.gray_9F9F9F,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_16, {}]}>
              Inefficient belts
            </Text>
            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() => {
                closePopup();
              }}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 25,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 25,
                }}
              />
            </TouchableOpacity>
          </View>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: AppColors.gray_BBB, marginTop: 20 },
            ]}
          >
            You currently don't have any in stock, Click the buy button to buy
            belts and challenge your friends.
          </Text>
          <CommonButton
            buttonStyle={{
              paddingVertical: 12,
              paddingHorizontal: 24,
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 10,
              shadowOpacity: 0,
              alignSelf: "flex-start",
              marginTop: 10,
              flex: 1,
            }}
            textStyle={[
              AppFontStyle.BOLD_ANYBODY_12,
              { color: AppColors.white },
            ]}
            title="Buy Belt"
            onTap={() => {
              // navigateToScreen(navigation, AppScreens.PurchaseScreen);
              closePopup();
            }}
          />
        </View>
      </View>
    </Modal>
  );
};

export default InefficientBeltsPopup;
